module.exports = __webpack_public_path__ + "img/JJC.d525a53c.jpg";